module.exports = __webpack_public_path__ + "static/media/Stellar Ace Queen Headboard - 155 cm_Charcoal.faf914a3.png";